<template lang="pug">
    .field-wrap(:class="[{'field-row': typeChild === 'row'}, {'field-column': typeChild === 'column'}, {'field-section': typeChild === 'section'}]")
        .field-item(v-for="(itemRow, index) in items"
            :class="{'image-item': itemRow.type === 'image'}")

            .field(v-if="itemRow['input-type'] === 'text'"
                :class="{'icon-wrap': itemRow.icon}")
                .label(v-if="itemRow.title") {{ itemRow.title }}

                .input-wrap(:class="status($v.field)")
                    .icon(v-if="itemRow.icon")
                        img(:src="itemRow.icon.src")
                    input(type='text'
                        :name='itemRow.placeholder'
                        @change="change(itemRow)"
                        v-model="inputField"
                        :class="status($v.field)"
                        :placeholder="itemRow.placeholder").input

            .field(v-if="itemRow['input-type'] === 'email'"
                :class="{'icon-wrap': itemRow.icon}")
                .label(v-if="itemRow.title") {{ itemRow.title }}

                .input-wrap(:class="status($v.field)")
                    .icon(v-if="itemRow.icon")
                        img(:src="itemRow.icon.src")
                    input(type='text'
                        :name='itemRow.placeholder'
                        v-model="inputField"
                        @change="change(itemRow)"
                        :class="status($v.field)"
                        :placeholder="itemRow.placeholder").input

            .field(v-if="itemRow['input-type'] === 'phone'"
                :class="{'icon-wrap': itemRow.icon}")
                .label(v-if="itemRow.title") {{ itemRow.title }}

                .input-wrap(:class="status($v.field)")
                    .icon(v-if="itemRow.icon")
                        img(:src="itemRow.icon.src")
                    input(type='text'
                        :name='itemRow.placeholder'
                        v-model="inputField"
                        @change="change(itemRow)"
                        v-mask="'### ### ####'"
                        @input="$v.field.$touch()"
                        :class="status($v.field)"
                        :placeholder="itemRow.placeholder").input

            .field(v-if="itemRow.type === 'select'"
                :class="{'icon-wrap': itemRow.icon}")
                .label(v-if="itemRow.title") {{ itemRow.title }}

                .input-wrap(:class="status($v.field)")
                    .icon(v-if="itemRow.icon")
                        img(:src="itemRow.icon.src")
                    v-select(v-model="inputField"
                        @input="change(itemRow)"
                        @change="$v.field.$touch()"
                        :class="status($v.field)"
                        :options="itemRow.options"
                        :placeholder="itemRow.placeholder"
                        :autocomplete="true")

            .field(v-if="itemRow['input-type'] === 'number'"
                :class="{'icon-wrap': itemRow.icon}")
                .label(v-if="itemRow.title") {{ itemRow.title }}

                .input-wrap(:class="status($v.field)")
                    .icon(v-if="itemRow.icon")
                        img(:src="itemRow.icon.src")
                    input(type='number'
                        :name='itemRow.placeholder'
                        @change="change(itemRow)"
                        :class="status($v.field)"
                        v-model="inputField"
                        :placeholder="itemRow.placeholder").input

            .field(v-if="itemRow.type === 'textarea'"
                :class="{'icon-textarea-wrap': itemRow.icon}")
                .label(v-if="itemRow.title") {{ itemRow.title }}

                .input-wrap(:class="status($v.field)")
                    .icon(v-if="itemRow.icon")
                        img(:src="itemRow.icon.src")
                    textarea(:name='itemRow.placeholder'
                        @change="change(itemRow)"
                        :class="status($v.field)"
                        v-model="inputField"
                        :placeholder="itemRow.placeholder").textarea

            .field(v-if="itemRow.type === 'button'")
                button(type="submit").btn {{ itemRow.title }}

            fields(v-if="itemRow.children && itemRow.children.length > 0"
                :typeChild="itemRow.type"
                :items="itemRow.children"
                @returnStatusToParent="formStatus =>$emit('returnStatusToParent', formStatus)")


</template>

<script>
    import Vue from 'vue'
    import Vuex from 'vuex'
    const mapState = Vuex.mapState
    import Vuelidate from 'vuelidate'
    import { required, email, minLength } from 'vuelidate/lib/validators'
    import VueScrollTo from 'vue-scrollto'
    import VueMask from 'v-mask'
    import vSelect from "vue-select";
    import "vue-select/dist/vue-select.css";
    Vue.component("v-select", vSelect);
    Vue.use(Vuelidate);
    Vue.use(VueScrollTo);

    Vue.use(VueMask);

    export default {
        name: "fields",
        props: [
            'items',
            'typeChild',
            'array',
        ],
        data: () => {
            return {
                field: '',
            }
        },
        watch: {
            "$v.$invalid": function() {
                this.$emit("returnStatusToParent", !this.$v.$invalid);
            }
        },
        methods: {
            change(item) {
                this.addNameField(item)
                this.$v.$touch()
            },
            status(validation) {
                return {
                    error: validation.$error,
                    dirty: validation.$dirty
                }
            },
            addNameField(item) {
                this.$store.commit('setFormField', { field: 'Contact Form Modal' + '.' + item['block-string-id'], value: this.field })
            },
            resetForm() {
                this.field = '';

                this.$v.$reset();


                this.$emit("returnStatusToParent", false);
            }
        },
        validations() {
            let rules = {}

            if (this.fieldRequired) {
                rules = { ...rules, required }
            }

            if (this.fieldType === 'email') {
                rules = { ...rules, email }
            }

            if (this.fieldType === 'phone') {
                rules = { ...rules, minLength: minLength(12) }
            }

            return {
                field: rules
            }
        },
        computed: {
            inputField: {
                get: function() {
                    return this.field;
                },
                set: function(value) {
                    this.field = value;
                }
            },
            fieldType: function () {
                return this.items[0]['input-type'] || 'text'
            },
            fieldRequired: function () {
                if(this.items[0].required) {
                    return this.items[0].required
                }
            },
        },
        mounted() {
            this.$eventPool.$on("touchChildFormModal", () => {
                this.$v.$touch()
                this.$emit("returnStatusToParent", !this.$v.$invalid);
            });

            this.$eventPool.$on("resetChildForm", () => {
                this.resetForm();
            });
        },
        destroyed() {
            this.$eventPool.$off("touchChildForm", () => {})

            this.$eventPool.$off("resetChildForm", () => {});
        }
    }
</script>

